// D3 (Studio Technique — version douce) design tokens.
// Hiérarchie de bordures à 3 niveaux, ombres subtiles, grille allégée,
// fonts Atelier (Lora serif + DM Sans + IBM Plex Mono).

import type { CSSProperties } from 'react';

export const T = {
  paper: '#f4f1ea',
  paperGrid: '#ddd8cc',
  paperSoft: '#ebe7dd',
  graphite: '#1c1c1c',
  graphiteSoft: '#2a2a2a',
  graphiteWarm: '#2c2720',
  rule: '#1c1c1c',
  vermillon: '#d63a17',
  vermillonDeep: '#a82b0e',
  blueprint: '#1d3a8a',
  muted: '#6b6b62',
  fade: '#9c9c8e',
  faint: '#cfc8b8',
  ok: '#2b7a3a',
  warn: '#b67513',
  // Bordures hiérarchisées
  borderStrong: '#1c1c1c',
  borderMid: '#b8b0a0',
  borderLight: '#ddd8cc',
  // Ombres subtiles
  shadowCard: '0 1px 4px rgba(28,28,28,0.06), 0 0 0 1px rgba(28,28,28,0.05)',
  shadowPanel: '0 2px 8px rgba(28,28,28,0.07)',
} as const;

// Pairing "Atelier" — Lora pour titres, DM Sans pour corps, IBM Plex Mono pour codes.
export const S = {
  mono: { fontFamily: '"IBM Plex Mono", ui-monospace, monospace' } as CSSProperties,
  sans: { fontFamily: '"DM Sans", system-ui, sans-serif' } as CSSProperties,
  serif: { fontFamily: '"Lora", Georgia, serif' } as CSSProperties,
};

// Grille allégée : 0.5 px au lieu de 1 px.
export const gridBg = (size = 32, color: string = T.paperGrid): CSSProperties => ({
  backgroundImage: `linear-gradient(${color} 0.5px, transparent 0.5px), linear-gradient(90deg, ${color} 0.5px, transparent 0.5px)`,
  backgroundSize: `${size}px ${size}px`,
});

// Border radius unifiés.
export const R = {
  tag: 3,
  button: 5,
  iconButton: 5,
  input: 5,
  segmented: 6,
  preview: 6,
  search: 6,
  table: 8,
  framed: 8,
  card: 10,
} as const;
